export const speakers = [
    {
        "id": "RXZlbnRQZW9wbGVfMzE0MzIyNjQ=",
        "type": "Moderator",
        "firstName": "Jonathan",
        "lastName": "Worsley",
        "jobTitle": "Chairman & CEO",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0Mzc=",
                "name": "Organisers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDI2MDMwMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTkwMzA=",
        "type": "Speaker",
        "firstName": "Waleed",
        "lastName": "Abualnadi",
        "jobTitle": "Commercial Director",
        "organization": "Saudi Icon Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/88c841025ae541499e96edae25303cdc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkyMDMwOQ==",
                    "createdAt": "2025-04-25 11:28:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTkwNjk=",
        "type": "Speaker",
        "firstName": "Abdullah",
        "lastName": "Azhari",
        "jobTitle": "CEO & Managing Director",
        "organization": "Saudi Icon Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4fdf53d37b004fe1a6d8cdf05e9fdd85.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjUyNw==",
                    "createdAt": "2025-04-25 11:28:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTkwOTU=",
        "type": "Speaker",
        "firstName": "Ayman",
        "lastName": "Ezzeddine",
        "jobTitle": "Director, Business Development, Middle East, Egypt and Pakistan",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/29bcc24eaa2e4b15877b20aaf9a571ae.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzNTU0NA==",
                    "createdAt": "2025-04-25 11:28:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTkzNDg=",
        "type": "Moderator",
        "firstName": "Yousef",
        "lastName": "Gamal El-Din",
        "jobTitle": "Former News-Anchor",
        "organization": "Bloomberg",
        "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODQ4NDQ1MQ==",
                    "createdAt": "2025-04-25 11:28:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTkzNzc=",
        "type": "Speaker",
        "firstName": "Steven",
        "lastName": "Greenway",
        "jobTitle": "Chief Executive Officer",
        "organization": "flyadeal",
        "photoUrl": "https://static.swapcard.com/public/images/135b3657e4e24a59ac1200f5bdf99a80.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTI4NzY4OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk0MDc=",
        "type": "Guest",
        "firstName": "Heidi",
        "lastName": "Grimwood",
        "jobTitle": "Vice President",
        "organization": "ELE | NA Elements of Nature",
        "photoUrl": "https://static.swapcard.com/public/images/eb20c4adab4d4074a0ae22542e4a75e6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Guest",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI2NjI2NA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk0OTc=",
        "type": "Speaker",
        "firstName": "Glenn",
        "lastName": "Mandziuk",
        "jobTitle": "Chief Executive Officer",
        "organization": "World Sustainable Hospitality Alliance",
        "photoUrl": "https://static.swapcard.com/public/images/b19e8296c97244568fcf237831af441c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQzMA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk1MjE=",
        "type": "Speaker",
        "firstName": "Omar",
        "lastName": "Romero",
        "jobTitle": "Chief Development & Luxury Officer",
        "organization": "Minor Hotel Group Limited",
        "photoUrl": "https://static.swapcard.com/public/images/0f99cc6201cf4279b6c1afe8f6c217f1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODQ4NTMzOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk2ODU=",
        "type": "Speaker",
        "firstName": "Johannes",
        "lastName": "Torpe",
        "jobTitle": "Designer & Musician",
        "organization": "Johannes Torpe Studios",
        "photoUrl": "https://static.swapcard.com/public/images/8da4c012896c43db8bf17de0638a22fc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTI4Nzg5Ng==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk3NTk=",
        "type": "Sponsor",
        "firstName": "Philip",
        "lastName": "Wooller",
        "jobTitle": "Area Director - Middle East and Africa",
        "organization": "STR",
        "photoUrl": "https://static.swapcard.com/public/images/b0e3e87fc85640eba57074bb73a59231.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Sponsor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjk0MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk4MzI=",
        "type": "Speaker",
        "firstName": "Jeff",
        "lastName": "Tisdall",
        "jobTitle": "Chief Business Officer, Global Head of Mixed-Use",
        "organization": "Accor One Living",
        "photoUrl": "https://static.swapcard.com/public/images/665f0d09e03b46308f0adb0fb8011c4e.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwODE2Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk4NDQ=",
        "type": "Moderator",
        "firstName": "Ben",
        "lastName": "Baseley-Walker",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Andart Global",
        "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM5OA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MTk5ODA=",
        "type": "Speaker",
        "firstName": "Luis Nicolas",
        "lastName": "Barrios",
        "jobTitle": "Regional Manager Innovation Education and Investment",
        "organization": "UN Tourism",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYyMjE0NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MjAwNjQ=",
        "type": "Delegate",
        "firstName": "Amir Ali",
        "lastName": "Golbarg",
        "jobTitle": "Senior Vice President - India, Middle East & Africa",
        "organization": "Minor Hotel Group Limited",
        "photoUrl": "https://static.swapcard.com/public/images/b262847250324bb7bf84f87e8cf6bf6b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM1NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MjAxMDI=",
        "type": "Speaker",
        "firstName": "Tariq",
        "lastName": "Dowidar",
        "jobTitle": "Vice President, KSA",
        "organization": "Aleph Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/45881074548642c7881bc4ae6e0a4784.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY5Ng==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MjAyMDc=",
        "type": "Moderator",
        "firstName": "Scott",
        "lastName": "Antel",
        "jobTitle": "Founder",
        "organization": "Scott's Fz",
        "photoUrl": "https://static.swapcard.com/public/images/f8adc05652d6499bb38ba9f43560f107.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1Ng==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MjAzNTE=",
        "type": "Speaker",
        "firstName": "Patrick",
        "lastName": "Smith",
        "jobTitle": "Chief Executive Officer",
        "organization": "Strive Services Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/54f79764c96e4a9eb94fc822fb7bad32.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY4MDYzMQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5Mzc2NDM=",
        "type": "Speaker",
        "firstName": "Jake",
        "lastName": "Haupert",
        "jobTitle": "Founder, Chair, and Chief of Innovation and Impact",
        "organization": "Transformational Travel Council",
        "photoUrl": "https://static.swapcard.com/public/images/f7beff0998f34f81828285391e0e2930.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTMwMDI4MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5Mzc4NzY=",
        "type": "Speaker",
        "firstName": "Ron",
        "lastName": "Pohl",
        "jobTitle": "President",
        "organization": "BWH Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/761b085b2385463baabb37776817bcae.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTMwMDQyOQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzY5MzgxNzg=",
        "type": "Speaker",
        "firstName": "Hossam",
        "lastName": "Al-Basrawi",
        "jobTitle": "Chief Executive Officer",
        "organization": "Alrajhi Capital",
        "photoUrl": "https://static.swapcard.com/public/images/ab06795985174d609056ebd5d02c872e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Financial Services / Banks",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTMwMDcwMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcwMDUxMzc=",
        "type": "Speaker",
        "firstName": "Gregory",
        "lastName": "Lanter",
        "jobTitle": "Group Deputy CEO",
        "organization": "Club Med",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjM1MzMzOQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcwMDUxOTU=",
        "type": "Speaker",
        "firstName": "Sultan Bader",
        "lastName": "Al-Otaibi",
        "jobTitle": "Chief Executive Officer",
        "organization": "Taiba Investments",
        "photoUrl": "https://static.swapcard.com/public/images/7b395ba5c8d146cb970582231d498e01.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODcwODQ0MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcwMDUyNjk=",
        "type": "Speaker",
        "firstName": "Hassan",
        "lastName": "Ahdab",
        "jobTitle": "Chief Hospitality Operations Officer",
        "organization": "Taiba Investments",
        "photoUrl": "https://static.swapcard.com/public/images/9cf68577bdff4a38be44c9fbf2850f25.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTM0Mjc2OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcwNDU2Njk=",
        "type": "Speaker",
        "firstName": "Carsten K.",
        "lastName": "Rath",
        "jobTitle": "Entrepreneur",
        "organization": "Passion for Excellence AG",
        "photoUrl": "https://static.swapcard.com/public/images/6e37976db2e44fa7aacf9e2b457f78f0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTM3NzI4MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcwNDU3NDA=",
        "type": "Moderator",
        "firstName": "Nikolina",
        "lastName": "Angelkova",
        "jobTitle": "Former Minister Tourism",
        "organization": "Bulgaria",
        "photoUrl": "https://static.swapcard.com/public/images/be577fb8e2b044c98cc51dc0dc10fb55.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTM3NzMzNA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcxMDM2Mzc=",
        "type": "Speaker",
        "firstName": "Adil",
        "lastName": "Jabrayilov",
        "jobTitle": "Development Director MENA",
        "organization": "Louvre Hotels Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTI5Njg3NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcxNDAzNzA=",
        "type": "Delegate;Sponsor",
        "firstName": "Panos",
        "lastName": "Loupasis",
        "jobTitle": "Market Managing Director Türkiye, Middle East & Africa",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Delegate;Sponsor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkyNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcxNjQ5MjY=",
        "type": "Speaker",
        "firstName": "Daniel von",
        "lastName": "Barloewen",
        "jobTitle": "Senior Vice President, Global Mixed-Use Development",
        "organization": "Accor One Living",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzcyMjQwNzQ=",
        "type": "Speaker",
        "firstName": "Muin",
        "lastName": "Serhan",
        "jobTitle": "Chief Executive Officer",
        "organization": "Amsa Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/2ca186381f1a453c84f2b9e39d502d5b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI2NjgwMg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzczNzE1MzY=",
        "type": "Speaker",
        "firstName": "Dr. Sarah",
        "lastName": "Gasim",
        "jobTitle": "Senior Vice President, Head of Hotels KSA",
        "organization": "JLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/295c94c5f792461ea1fb5840b840ad14.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk0NjQzNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc0OTY5MTI=",
        "type": "Moderator",
        "firstName": "Jessy El",
        "lastName": "Murr",
        "jobTitle": "Former Journalist",
        "organization": "BBC",
        "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTY5NTc5MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc0OTY5MjU=",
        "type": "Speaker",
        "firstName": "HH Prince Bandar bin Saud bin Khalid",
        "lastName": "Al Saud",
        "jobTitle": "Secretary General, King Faisal Foundation (KFF)",
        "organization": "Chairman of the Board of Directors, Al Khozama Investment Company",
        "photoUrl": "https://static.swapcard.com/public/images/0f3466754aec406ab2b64862743c639f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTY5NTgwMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc1NTIwNTA=",
        "type": "Moderator",
        "firstName": "Oussama",
        "lastName": "El Kadiri",
        "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure Advisory Services MENA",
        "organization": "Knight Frank",
        "photoUrl": "https://static.swapcard.com/public/images/dc29cc55509a4976a69bfc9f6d8f860c.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI5NTI1OA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc1ODUwMzU=",
        "type": "Speaker",
        "firstName": "Dr. Abeer",
        "lastName": "Alamri",
        "jobTitle": "Skills Development and Talent Optimization Expert",
        "organization": "",
        "photoUrl": "https://static.swapcard.com/public/images/a96df3d5f0c84807a351df07dfc4e15c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTc1NzUxNA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc1OTk0MzU=",
        "type": "Speaker",
        "firstName": "Mohammad",
        "lastName": "Alathel",
        "jobTitle": "Vice Chairman",
        "organization": "Amsa Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/2127beca4264403b93ceea09579d1af7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDcxNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc1OTk1ODI=",
        "type": "Speaker",
        "firstName": "Maud",
        "lastName": "Bailly",
        "jobTitle": "Chief Executive Officer",
        "organization": "Sofitel Legend, Sofitel, MGallery & Emblems",
        "photoUrl": "https://static.swapcard.com/public/images/edfc860d7115437ab95c00263a3833b7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTc2ODk1MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2MDY1NjI=",
        "type": "Speaker",
        "firstName": "Michael Acton",
        "lastName": "Smith",
        "jobTitle": "Co-Founder & Executive Chairman",
        "organization": "Calm",
        "photoUrl": "https://static.swapcard.com/public/images/aeeea1ec1faf489f89b37288836b84c9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTc3NDA2Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2MjE0OTc=",
        "type": "Speaker",
        "firstName": "Ana Lobo",
        "lastName": "Martins",
        "jobTitle": "Director, Interior Design",
        "organization": "ARC International Design Consultants",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1MzU5NA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2MzgyODI=",
        "type": "Speaker",
        "firstName": "Khalid",
        "lastName": "Alsatti",
        "jobTitle": "Senior Specialist",
        "organization": "UN Tourism",
        "photoUrl": "https://static.swapcard.com/public/images/fe82653e3724419b8b5e7ba32b3f3066.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTc5NzAyMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2Mzg4ODQ=",
        "type": "Speaker",
        "firstName": "Lindsay",
        "lastName": "McGinn",
        "jobTitle": "Global Vice President, Residential Marketing",
        "organization": "Accor One Living",
        "photoUrl": "https://static.swapcard.com/public/images/40e3583390b74ba990aac2988788e0b8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTc5NzQzNA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2Mzk0NTc=",
        "type": "Moderator",
        "firstName": "Arjun",
        "lastName": "Singh",
        "jobTitle": "Founding Director",
        "organization": "Hospitality and Tourism Management  Robert C. Vackar College of Business & Entrepreneurship",
        "photoUrl": "https://static.swapcard.com/public/images/1fb7dff7af2d430e9959241d9694222f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI2NjI1Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2NzMzOTI=",
        "type": "Speaker",
        "firstName": "Gavin",
        "lastName": "Weaver",
        "jobTitle": "Regional Director",
        "organization": "AtkinsRéalis",
        "photoUrl": "https://static.swapcard.com/public/images/7c95a4ed367e40a4b33fe03dc3cc35bc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODE2MTEwNA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc2Nzc1NjE=",
        "type": "Speaker",
        "firstName": "Hicham",
        "lastName": "Hassouni",
        "jobTitle": "Chief Business Officer",
        "organization": "Our Habitas, EVP KSA Ennismore",
        "photoUrl": "https://static.swapcard.com/public/images/aece1262c2e749f39b7ea4cd5a20e880.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODM0MTQ3Nw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3MjY2NjQ=",
        "type": "Moderator",
        "firstName": "Lameese",
        "lastName": "Damiri",
        "jobTitle": "Senior Education Specialist",
        "organization": "UNTourism",
        "photoUrl": "https://static.swapcard.com/public/images/6f7ac5e6899849429e30e768190d52aa.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTg1MjU1Ng==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3MjY2OTI=",
        "type": "Speaker",
        "firstName": "Dr․Fabien",
        "lastName": "Fresnel",
        "jobTitle": "Chief Executive Officer",
        "organization": "The Riyadh School of Tourism and Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/d3fc4fead393401eb9b123f9d14e190e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTg1MjU4MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3NjE1ODU=",
        "type": "Speaker",
        "firstName": "Fahad",
        "lastName": "Mohammed Alobailan",
        "jobTitle": "Chief Executive Officer",
        "organization": "BAAN Holding",
        "photoUrl": "https://static.swapcard.com/public/images/7a338419909044c5b3a29f6d9820e408.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTg3NzMwNA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3NjMwNjg=",
        "type": "Speaker",
        "firstName": "David",
        "lastName": "Thomson",
        "jobTitle": "Senior Vice President Development",
        "organization": "The First Group Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/f1cef20495ca4b618a5c6a58e24af95e.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjQ4NjUyMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3OTY5NzA=",
        "type": "Speaker",
        "firstName": "Tommy",
        "lastName": "Lai",
        "jobTitle": "Chief Executive Officer",
        "organization": "Alyvate Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/bc47785a482845cbbbe015c71339eca7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTkwNTA2MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3OTczNDA=",
        "type": "Speaker",
        "firstName": "Julien",
        "lastName": "Laloye",
        "jobTitle": "Senior Director, Mixed-Use Development (EMEA)",
        "organization": "Marriott International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/87c9b931df3243d1a7ea88d1c7554587.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTQwMA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3OTczNzI=",
        "type": "Moderator",
        "firstName": "Stefan",
        "lastName": "Breg",
        "jobTitle": "Managing Partner-Consulting",
        "organization": "KEANE: Consult & Create",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/41525c7c9fe74668bbba9fb57926cf94.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk4Mjc0OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc3OTczNzc=",
        "type": "Speaker",
        "firstName": "Ola",
        "lastName": "Kayal",
        "jobTitle": "Founder & CEO",
        "organization": "Nabati",
        "photoUrl": "https://static.swapcard.com/public/images/6a9f9d2752154c5393f4e3a56a69651c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Restaurant Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTkwNTM3MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc4MjQxMjA=",
        "type": "Speaker",
        "firstName": "Serena",
        "lastName": "Lim",
        "jobTitle": "Chief Growth Officer",
        "organization": "The Ascott Limited",
        "photoUrl": "https://static.swapcard.com/public/images/cca0cb3e45514a56a843e289363626ad.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTM5NA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc4MjQzMTA=",
        "type": "Speaker",
        "firstName": "Professor Marc",
        "lastName": "Lepere",
        "jobTitle": "Lead in ESG & Sustainability, Executive Education, Department of Banking & Finance",
        "organization": "King’s Business School",
        "photoUrl": "https://static.swapcard.com/public/images/349224791da74287bc999e28ae9c3c0e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTkyNjU2NA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc4ODg5NDk=",
        "type": "Speaker",
        "firstName": "Maher Abou",
        "lastName": "Nasr",
        "jobTitle": "Vice President Operations Saudi Arabia",
        "organization": "IHG Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e69da694e74461e96c99804a27218ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTc5NzI2OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc5MTM3MjQ=",
        "type": "Speaker",
        "firstName": "Nick",
        "lastName": "Candy",
        "jobTitle": "Chief Executive Officer",
        "organization": "Candy Capital",
        "photoUrl": "https://static.swapcard.com/public/images/97a1ef7bc8bb47fc9a6ce1108c7fc3a3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MTk5MDg5MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc5NDcxMjc=",
        "type": "Speaker",
        "firstName": "Benoît-Etienne",
        "lastName": "Domenget",
        "jobTitle": "Chief Executive Officer",
        "organization": "Sommet Education",
        "photoUrl": "https://static.swapcard.com/public/images/440ed8fcbcaf42e79a006e97e8553b98.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjAxNTUxOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzc5OTAyMzA=",
        "type": "Speaker",
        "firstName": "Joe",
        "lastName": "Tabet",
        "jobTitle": "Founder & Managing Director",
        "organization": "JT+Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTc5MzcwNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgwNDAwMzk=",
        "type": "Moderator",
        "firstName": "Adrian",
        "lastName": "Artimov",
        "jobTitle": "Chief Commercial Officer",
        "organization": "Sommet Education",
        "photoUrl": "https://static.swapcard.com/public/images/839a45698a0e4ad6b590ac1fdf344483.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjU0Mjg3MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgwNjYxMDQ=",
        "type": "Speaker",
        "firstName": "Jerry",
        "lastName": "Inzerillo",
        "jobTitle": "Group CEO",
        "organization": "Diriyah Company",
        "photoUrl": "https://static.swapcard.com/public/images/b946c29ec7c24b2091410172ac1ed515.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjEwMzAwMA==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgwNjYxMzU=",
        "type": "Speaker",
        "firstName": "Sean",
        "lastName": "Hehir",
        "jobTitle": "President & CEO",
        "organization": "Trinity Investments",
        "photoUrl": "https://static.swapcard.com/public/images/2277a5f9559c4030b9dbe17935b2d9d9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjEwMzAyNw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgwNzE4ODg=",
        "type": "Speaker",
        "firstName": "Victor",
        "lastName": "Abou Ghanem",
        "jobTitle": "Chief Executive Officer",
        "organization": "Story Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/52f3140d9d43407580755a2aefbe53d0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjEwNjM4Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxMDUyOTY=",
        "type": "Moderator",
        "firstName": "Aradhana",
        "lastName": "Khowala",
        "jobTitle": "CEO & Regenerative Tourism Expert",
        "organization": "Aptamind Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM2NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxMDUzMDU=",
        "type": "Speaker",
        "firstName": "Harry",
        "lastName": "Theoharis",
        "jobTitle": "Member of Parliament, Hellenic Parliament",
        "organization": "Candidate for UN Tourism Secretary-General",
        "photoUrl": "https://static.swapcard.com/public/images/30a65492fbff4edcb104c974fa9a4643.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjEzMDc3Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxNjg2MTE=",
        "type": "Speaker",
        "firstName": "Cyril",
        "lastName": "Piaia",
        "jobTitle": "Chief Executive Officer",
        "organization": "Confidential",
        "photoUrl": "https://static.swapcard.com/public/images/ddbade2a26114f93981f3e1ca21238f4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjE2MTM2OA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxNjk3MDg=",
        "type": "Speaker",
        "firstName": "Ahmad",
        "lastName": "Arab",
        "jobTitle": "Founding Partner",
        "organization": "Horwath HTL Saudi",
        "photoUrl": "https://static.swapcard.com/public/images/fc79302a35f94bfca7d72c5399ca839d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjE2MjExNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxNjk3MzE=",
        "type": "Moderator",
        "firstName": "Ali",
        "lastName": "Manzoor",
        "jobTitle": "Senior Director Head of Hospitality, Hotels & Tourism",
        "organization": "CBRE MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxNjk3NjQ=",
        "type": "Speaker",
        "firstName": "Muhammad",
        "lastName": "Bassrawi",
        "jobTitle": "President Domestic Tourism Business Unit",
        "organization": "Saudi Tourism Authority",
        "photoUrl": "https://static.swapcard.com/public/images/68d5ac9db08a4bc8b12240a95d18bc31.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjE2MjE1NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgxNzIwMTc=",
        "type": "Delegate",
        "firstName": "Siegfried",
        "lastName": "Nierhaus",
        "jobTitle": "Vice President & Head of Development Middle East, India and Africa",
        "organization": "H World International",
        "photoUrl": "https://static.swapcard.com/public/images/1520d185856a42d8883a3dcb4b287cd1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQxNzQzOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgyMTMxMzg=",
        "type": "Speaker",
        "firstName": "Anouck",
        "lastName": "Weiss",
        "jobTitle": "Chief Communication Officer, Sommet Education",
        "organization": "Co-founder and Executive Vice President, Sommet Education Foundation",
        "photoUrl": "https://static.swapcard.com/public/images/4aa512d63690417fb592e5e14fa6118a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjE5MTk5Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgyMTg1MjQ=",
        "type": "Speaker",
        "firstName": "Sundip",
        "lastName": "Patel",
        "jobTitle": "Chief Executive Officer",
        "organization": "Ezdaher Financing Company",
        "photoUrl": "https://static.swapcard.com/public/images/8cadb1f6b939436ab08ad4dd957f35e2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Financial Services / Banks",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjE5NDE1OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgyMzI0ODA=",
        "type": "Speaker",
        "firstName": "Carlos",
        "lastName": "Díez de la Lastra",
        "jobTitle": "Chief Executive Officer",
        "organization": "Les Roches",
        "photoUrl": "https://static.swapcard.com/public/images/518a18db85dd40628e26d9847a175eb3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjIwMjkxOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgzMzQ4NTI=",
        "type": "Speaker",
        "firstName": "Lindsay",
        "lastName": "Madden-Nadeu",
        "jobTitle": "Sr. Director Wellness Strategy",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/87e1ecef3d3c4645add000e7ba2a1f90.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjI3ODA2Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzgzMzUwNjI=",
        "type": "Moderator",
        "firstName": "Amr",
        "lastName": "Fakiha",
        "jobTitle": "Strategy & Growth Director, Project & Development Services, KSA",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/41a6c6efacdc4eb49a49393f6a210832.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjI3ODIzOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MzY2MzU=",
        "type": "Speaker",
        "firstName": "Paul",
        "lastName": "Bridger",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rove Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQxOQ==",
                    "createdAt": "2025-04-25 11:28:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0NDIwOTk=",
        "type": "Moderator",
        "firstName": "Catherine",
        "lastName": "Edwards",
        "jobTitle": "Chief Strategy Officer",
        "organization": "QUO Global",
        "photoUrl": "https://static.swapcard.com/public/images/56b5c581532147f6a330a6a89310b1b3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkxOTE2OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg1MzMwNzM=",
        "type": "Speaker",
        "firstName": "Ibrahim",
        "lastName": "Osta",
        "jobTitle": "Global Tourism Lead and Senior Economic Growth Advisor",
        "organization": "Chemonics International",
        "photoUrl": "https://static.swapcard.com/public/images/303983429b0e479694156475cf332e22.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjQzODM2MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2NDAwNTM=",
        "type": "Speaker",
        "firstName": "Eddy",
        "lastName": "Tannous",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/0ea10113e8f64d0795d891c9d1769812.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkxNjI0MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2NzE0MDY=",
        "type": "Speaker",
        "firstName": "Duncan",
        "lastName": "O’Rourke",
        "jobTitle": "Chief Executive Officer, Middle East, Africa & Asia Pacific - Premium, Midscale & Economy",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/1c3e3941e7364f5499e61c5ed5068869.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NDM5MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2OTc5NDA=",
        "type": "Speaker",
        "firstName": "Layla",
        "lastName": "Alamri",
        "jobTitle": "Education Senior Manager",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/62dcb9c47b304c07b3a86777001b0d5d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjU2NzM5OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2OTgxNjQ=",
        "type": "Moderator",
        "firstName": "Andre",
        "lastName": "Wiringa",
        "jobTitle": "Founder & CEO",
        "organization": "Start Reverse",
        "photoUrl": "https://static.swapcard.com/public/images/da31899a1026461a9cb04b6d60b0be52.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zOTAwMDIyOQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2OTgyOTA=",
        "type": "Speaker",
        "firstName": "Yasser Faisal",
        "lastName": "Al-Sharif",
        "jobTitle": "Founder",
        "organization": "Al Sadu Advisory",
        "photoUrl": "https://static.swapcard.com/public/images/1a163333261347d8a4e102ed07bf4598.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjU2NzY3OQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2OTg0NDc=",
        "type": "Speaker",
        "firstName": "Imran",
        "lastName": "Changezi",
        "jobTitle": "Executive Director Hospitality Development & Dean of Centre Expertise, CoE",
        "organization": "Diriyah Company",
        "photoUrl": "https://static.swapcard.com/public/images/f9218e8dc3d1467883cad34709a59cf1.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjU2NzgwMQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3NDMyOTQ=",
        "type": "Delegate",
        "firstName": "Govind",
        "lastName": "Mundra",
        "jobTitle": "Head of Development - MEA",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY5NA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3NDczODY=",
        "type": "Speaker",
        "firstName": "Amin",
        "lastName": "Ismail",
        "jobTitle": "Managing Director",
        "organization": "Certares",
        "photoUrl": "https://static.swapcard.com/public/images/c1ce509234ad4a169b5d394c3565b7e3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjYwNTc0Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3NDc1NTU=",
        "type": "Moderator",
        "firstName": "Richard",
        "lastName": "Williamson",
        "jobTitle": "Chief Operating Officer",
        "organization": "Considerate Group",
        "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTMwMDI0MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3NDc3MDY=",
        "type": "Moderator",
        "firstName": "Linh K.",
        "lastName": "Vu",
        "jobTitle": "Owner & Managing Director",
        "organization": "Key Hospitality Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/2e26cd668f984527a1694e1fa6459c8d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwODMwNw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3NDgwMzQ=",
        "type": "Speaker",
        "firstName": "Sally",
        "lastName": "Maier-Yip",
        "jobTitle": "Founder and Managing Director",
        "organization": "11K Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/e167271ea40e48a09196616faa91965f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI5ODY1Nw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg3OTM0NDg=",
        "type": "Speaker",
        "firstName": "Stephen",
        "lastName": "Cheesebrough",
        "jobTitle": "Head of Development",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/0f320eb6971948a3a0d568db60bb941a.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjYzMzE2MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg4ODgxOTg=",
        "type": "Speaker",
        "firstName": "Hussam",
        "lastName": "Alhuzaimi",
        "jobTitle": "Co-Founder & CEO",
        "organization": "Evolve Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/e801aa11e54b4bbd8fa458a7fc56210d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjY4NTc3NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg5ODU0MTQ=",
        "type": "Speaker",
        "firstName": "Jan-Patrick",
        "lastName": "Krüger",
        "jobTitle": "Managing Director",
        "organization": "Pandox AB",
        "photoUrl": "https://static.swapcard.com/public/images/52a0e4c54d73424eba2ec8fac78f2619.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjc2MjYyOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg5ODU0NzM=",
        "type": "Speaker",
        "firstName": "Olivier",
        "lastName": "Harnisch",
        "jobTitle": "Founder & CEO",
        "organization": "Lunasole Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/ba61936090334109a5f56e274ade06c9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjc2MjY3NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwMTg4MzM=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Nasra",
        "jobTitle": "Head of Hotel Advisory",
        "organization": "Colliers MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjI0OTIzNw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwMzY4NDc=",
        "type": "Speaker",
        "firstName": "Marloes",
        "lastName": "Knippenberg",
        "jobTitle": "Chief Executive Officer",
        "organization": "Kerten Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE0ODAzMA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwMzY4NTU=",
        "type": "Moderator",
        "firstName": "Ebrahim",
        "lastName": "Al Qassab",
        "jobTitle": "Projects Director",
        "organization": "Baraka for Real Estate Development & Investment",
        "photoUrl": "https://static.swapcard.com/public/images/d955479934204a2f8256e0534ec058d8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgwMTc4MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNTYzODY=",
        "type": "Speaker",
        "firstName": "George",
        "lastName": "Bos",
        "jobTitle": "Founder",
        "organization": "The Natural Bottle",
        "photoUrl": "https://static.swapcard.com/public/images/e70936d9e2454ff5a458ede8172b6860.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODcwMjYyOA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNTYzODc=",
        "type": "Speaker",
        "firstName": "Sarah",
        "lastName": "Albaiz",
        "jobTitle": "Managing director",
        "organization": "Qantara",
        "photoUrl": "https://static.swapcard.com/public/images/92cd6e668b364437a639257e07ba12e9.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgwNzY4Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNTczMzc=",
        "type": "Speaker",
        "firstName": "Ibrahim",
        "lastName": "Alsini",
        "jobTitle": "Executive Partner",
        "organization": "Inaar",
        "photoUrl": "https://static.swapcard.com/public/images/30e0413f819443c987dd30afe7faa919.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgxNTcyNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjIyNjY=",
        "type": "Moderator",
        "firstName": "Caty",
        "lastName": "Batten",
        "jobTitle": "Net Positive Innovation Lead",
        "organization": "World Sustainable Hospitality Alliance",
        "photoUrl": "https://static.swapcard.com/public/images/9319aed7c71b4babb23f9b95cad8c84c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgxOTQ5MQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjI0Mjk=",
        "type": "Speaker",
        "firstName": "Rohan",
        "lastName": "Ranade",
        "jobTitle": "Associate Vice President, Real Estate & Development",
        "organization": "The Indian Hotels Company Limited",
        "photoUrl": "https://static.swapcard.com/public/images/5c50ff2690024f8e88f60a8ffb14bc17.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY4MA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjYxNTU=",
        "type": "Speaker",
        "firstName": "Christophe",
        "lastName": "Beauvilain",
        "jobTitle": "Managing Partner",
        "organization": "Pygmalion Capital",
        "photoUrl": "https://static.swapcard.com/public/images/517b4a0b6d2947d3bcdb39aca538b4e7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgyMjUzMA==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjYyNzI=",
        "type": "Speaker",
        "firstName": "Muna Bu",
        "lastName": "Khamseen",
        "jobTitle": "Executive Assistant Manager",
        "organization": "Grand Hyatt Al Khobar Hotel & Residences",
        "photoUrl": "https://static.swapcard.com/public/images/f30e328325414f138d0ed91eb8ef40b6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgyMjYyOQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjYyNzk=",
        "type": "Moderator",
        "firstName": "Dunia",
        "lastName": "Joulani",
        "jobTitle": "Partner | Head of Travel, Hospitality and Leisure",
        "organization": "Deloitte Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/e5df3501067d4a65bfff3c6426c6e5dc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2ODI5Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjYyOTU=",
        "type": "Speaker",
        "firstName": "James",
        "lastName": "Edmondson",
        "jobTitle": "Director Infrastructure & Real Estate",
        "organization": "Deloitte Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/b4c6da4cc95345c3a24107555c9fd881.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2ODI5Mw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODY2NTE=",
        "type": "Speaker",
        "firstName": "Majed",
        "lastName": "Kaki",
        "jobTitle": "Vice President Business Development",
        "organization": "Elaf Group",
        "photoUrl": "https://static.swapcard.com/public/images/8acd316f3c1f44b583238b3133d41f94.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjAzOTU4NQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODcyNzU=",
        "type": "Speaker",
        "firstName": "Dr. Fahad",
        "lastName": "Al Otaibi",
        "jobTitle": "Senior Advisor at the Architecture & Design Commission",
        "organization": "Ministry of Culture",
        "photoUrl": "https://static.swapcard.com/public/images/fd1e2b7517d74ea8ace8d78ff40b9a9c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgzOTYyNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODcyODI=",
        "type": "Speaker",
        "firstName": "Dr. Ahmed",
        "lastName": "Abdulwahab Khan Alhashimi",
        "jobTitle": "Chief Business Development Officer (CBDO)",
        "organization": "Sumou Investment Global",
        "photoUrl": "https://static.swapcard.com/public/images/f10d745e815d4ad1bf7cdbcbb736f9fc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgzOTYyOA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODczNzI=",
        "type": "Speaker",
        "firstName": "Lena",
        "lastName": "AlAmeel",
        "jobTitle": "Founder & Creatrix",
        "organization": "Barriya",
        "photoUrl": "https://static.swapcard.com/public/images/bdf214f92352452d9e58df6175ee058d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgzOTY5OA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODc2ODA=",
        "type": "Speaker",
        "firstName": "Asif",
        "lastName": "Alidina",
        "jobTitle": "Co-Founder & CEO",
        "organization": "Inntelo AI",
        "photoUrl": "https://static.swapcard.com/public/images/1495f0f1b93c4bb38b00242a89aaf7bc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjgzOTk0Mg==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODgzMzk=",
        "type": "Speaker",
        "firstName": "Israa",
        "lastName": "Sammoura",
        "jobTitle": "Founder & CEO",
        "organization": "Meyraki",
        "photoUrl": "https://static.swapcard.com/public/images/af9f243701714499b2a0d7fd38b52204.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjg0MDQ3Mg==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwODg2MTk=",
        "type": "Speaker",
        "firstName": "Alexey",
        "lastName": "Korobkin",
        "jobTitle": "Senior Director Development",
        "organization": "IHG Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/4a630fefcc5e4195bf62d40aac672cf6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjI2MTQwNA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwOTk5NjI=",
        "type": "Speaker",
        "firstName": "Saurabh",
        "lastName": "Tiwari",
        "jobTitle": "Area Director - Operations, Middle East & CIS",
        "organization": "The Indian Hotels Company Limited (IHCL)",
        "photoUrl": "https://static.swapcard.com/public/images/8586cf1bbe494758b8b061fb551ae9a3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjIyNjYyMA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxMDMzMzA=",
        "type": "Speaker",
        "firstName": "Mark",
        "lastName": "Sperring",
        "jobTitle": "Regional PMC Director",
        "organization": "Compass Project Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/6ff1432405ee415bb39673c95d233565.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjg1MTgyNA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxMzI5ODE=",
        "type": "Moderator",
        "firstName": "Keri",
        "lastName": "Watkins",
        "jobTitle": "Co-Head of Real Estate & Hospitality, MENA",
        "organization": "Baker & McKenzie LLP",
        "photoUrl": "https://static.swapcard.com/public/images/6aaf19529dfa48399c84a077374275d3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTQ1NA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxMzMwMDM=",
        "type": "Moderator",
        "firstName": "Khaled",
        "lastName": "Zowayed",
        "jobTitle": "Partner, Co-Head of Real Estate and Hospitality Middle East",
        "organization": "Baker McKenzie",
        "photoUrl": "https://static.swapcard.com/public/images/dd92179458104c9f9d5b2de995de9bd8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzA2MA==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxNjIwMTE=",
        "type": "Moderator",
        "firstName": "Maximilian",
        "lastName": "Quack",
        "jobTitle": "Senior Vice President, Hotels & Hospitality MEA",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/bcd83ca8e2534894bc87cd4b98524fac.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjU3ODYwMw==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxNjc1Nzk=",
        "type": "Speaker",
        "firstName": "Rashid",
        "lastName": "Aboobacker",
        "jobTitle": "Portfolio Director",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/657107b0213243948feee33d7bdfc6ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjAyNTM1Nw==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkxNjgxOTI=",
        "type": "Speaker",
        "firstName": "AlaaEldin",
        "lastName": "Saleh",
        "jobTitle": "Chief Hotels Operating Officer",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://static.swapcard.com/public/images/099fd8b9c3ec4de6b7e840eae27f24a5.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MjkwMTI5MQ==",
                    "createdAt": "2025-04-25 11:28:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE2OTM=",
        "type": "Moderator",
        "firstName": "Reina",
        "lastName": "Takla",
        "jobTitle": "Business Editor",
        "organization": "ARAB NEWS",
        "photoUrl": "https://static.swapcard.com/public/images/75bf6bb86df141c392fe1da3ffe27aa2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media & PR",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI4MjQwMw==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE2OTY=",
        "type": "Speaker",
        "firstName": "Daniel",
        "lastName": "Hill",
        "jobTitle": "Chief Executive Officer",
        "organization": "AQUIVIO",
        "photoUrl": "https://static.swapcard.com/public/images/ce68aa18215c4e19b6fbd29e0fee5bca.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODI2NzI5Mg==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3MDE=",
        "type": "Speaker",
        "firstName": "Talal",
        "lastName": "Yousif",
        "jobTitle": "Director - Lodging Development",
        "organization": "Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/428a15093f314eee8b743a4763a1cd75.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDYzNQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3MTc=",
        "type": "Speaker",
        "firstName": "Paul",
        "lastName": "Keen",
        "jobTitle": "Director of Operations and Culture",
        "organization": "QUO",
        "photoUrl": "https://static.swapcard.com/public/images/da1c333c4d7a4bcd88d24e83716607d3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTgyMjIxMQ==",
                    "createdAt": "2025-04-25 11:28:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3NTA=",
        "type": "Speaker",
        "firstName": "Dimitris",
        "lastName": "Manikis",
        "jobTitle": "President, Europe, Middle East, Eurasia and Africa (EMEA)",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/af79623c9c6b421abb885caf4ccb29d4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzk1Mg==",
                    "createdAt": "2025-04-25 11:28:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3NTg=",
        "type": "Speaker",
        "firstName": "Imshan",
        "lastName": "Jamal",
        "jobTitle": "Managing Director & Co-Founder",
        "organization": "EQ Group",
        "photoUrl": "https://static.swapcard.com/public/images/4696035bb7a1453ea9e847140c3d223f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV85MjQ4OTk0",
                    "createdAt": "2025-04-25 11:28:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3NzI=",
        "type": "Speaker",
        "firstName": "Paul Kendall",
        "lastName": "Stevens",
        "jobTitle": "Chief Operating Officer - MEA",
        "organization": "AccorHotels Middle East & Africa FZ-LLC",
        "photoUrl": "https://static.swapcard.com/public/images/f81c1c9005f34df39acff45f0049c96a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NDM5Mg==",
                    "createdAt": "2025-04-25 11:28:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyMDE3NzM=",
        "type": "Speaker",
        "firstName": "Theodor",
        "lastName": "Kubak",
        "jobTitle": "Co-Founder, President Emeritus; Director of the Supervisory Board, HAMA Europe",
        "organization": "Managing Partner, Arbireo Hospitality Invest",
        "photoUrl": "https://static.swapcard.com/public/images/d4b31ffd5bbf4a779499a807ec6d7d44.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzk4MQ==",
                    "createdAt": "2025-04-25 11:28:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyNTk2NTA=",
        "type": "Speaker",
        "firstName": "Aseem",
        "lastName": "Kapoor",
        "jobTitle": "Founder & Chief Executive",
        "organization": "ARK People Solutions",
        "photoUrl": "https://static.swapcard.com/public/images/884c20583e464ec89357946867bc7743.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODMwMjA4OA==",
                    "createdAt": "2025-04-28 12:57:49"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyNjIxNjQ=",
        "type": "Speaker",
        "firstName": "Naif",
        "lastName": "AlMadi",
        "jobTitle": "Chief Business Officer",
        "organization": "Tourism Development Fund",
        "photoUrl": "https://static.swapcard.com/public/images/17626dede6254db69d1e10fd284b2839.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjk3MDA4Mw==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyNjQ0NTc=",
        "type": "Moderator",
        "firstName": "Sarah",
        "lastName": "Varghese",
        "jobTitle": "Global Head of Cities",
        "organization": "KPMG Saudi Arabia",
        "photoUrl": "https://static.swapcard.com/public/images/e46183acffe546e3aafb6f2d4e0c87b6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjk3MTY3Ng==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyNjY1ODA=",
        "type": "Speaker",
        "firstName": "Abdulrahman",
        "lastName": "Ibrahim",
        "jobTitle": "Chief Data and Innovation Officer",
        "organization": "Madinah Development Authority",
        "photoUrl": "https://static.swapcard.com/public/images/bd2ff042a6b6469a85f66c52328c07bc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80Mjk3MzI1OA==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyNjY3OTE=",
        "type": "Speaker",
        "firstName": "Samer",
        "lastName": "Sabra",
        "jobTitle": "Chief Asset Management Officer",
        "organization": "Jabal Omar Development Co.",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d70a454a25eb49d39b9086c7bb899092.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzMDAwOA==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkyOTU1ODE=",
        "type": "Speaker",
        "firstName": "Stephen",
        "lastName": "Rossouw",
        "jobTitle": "Senior Director of Development",
        "organization": "New Murabba Development Company",
        "photoUrl": "https://static.swapcard.com/public/images/f0f81072af1e4c2c94bef5b9af555e52.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODY2NTA3NQ==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkzMjk3OTg=",
        "type": "Speaker",
        "firstName": "Moustafa",
        "lastName": "Said",
        "jobTitle": "Founder & Partner",
        "organization": "Wisefields",
        "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2NDg4Ng==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkzMzYxMTQ=",
        "type": null,
        "firstName": "Daria",
        "lastName": "Smith",
        "jobTitle": "Portfolio Director",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/075d2422d51b4107acf37a36606914a3.webp",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0Mzc=",
                "name": "Organisers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE1NjA1MA==",
                    "createdAt": "2025-04-30 13:07:25"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkzOTA1MDI=",
        "type": "Moderator",
        "firstName": "Rico",
        "lastName": "Picenoni",
        "jobTitle": "Head of Global Residential Development Consultancy",
        "organization": "Savills",
        "photoUrl": "https://static.swapcard.com/public/images/5f9894b3287d4f55aeeb70c91486e8ed.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzA3MzUwNQ==",
                    "createdAt": "2025-05-02 15:01:23"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkzOTIxNjI=",
        "type": "Moderator",
        "firstName": "Rhonda",
        "lastName": "Hare",
        "jobTitle": "General Legal Counsel",
        "organization": "Ennismore",
        "photoUrl": "https://static.swapcard.com/public/images/d9b704e2c809432c8f726b912549a0fb.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODkyNzI4Nw==",
                    "createdAt": "2025-05-02 15:01:23"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkzOTQ0Njc=",
        "type": "Speaker",
        "firstName": "Joao",
        "lastName": "Cravo",
        "jobTitle": "Vice President for Asset Management",
        "organization": "United Hospitality Management",
        "photoUrl": "https://static.swapcard.com/public/images/47e5e9bd8e7945f0a673016cfabaf97d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzA3NjUxMQ==",
                    "createdAt": "2025-05-02 15:01:23"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MTgzODc=",
        "type": "Speaker",
        "firstName": "Lama",
        "lastName": "AlQawasmi",
        "jobTitle": "Co-Founder & COO",
        "organization": "Hospitality Talents",
        "photoUrl": "https://static.swapcard.com/public/images/5d27d4543c2a4075b57e2c418d0fbda4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzA5MzcyNQ==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MjI1MjY=",
        "type": "Speaker",
        "firstName": "Khalid",
        "lastName": "Mulla",
        "jobTitle": "Chief Financial Officer",
        "organization": "Rua al Madinah",
        "photoUrl": "https://static.swapcard.com/public/images/7de0123377d14371b972a4ac5f480405.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzA5NzA4Mw==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MjU1NTc=",
        "type": "Speaker",
        "firstName": "Mohammed",
        "lastName": "Marghalani",
        "jobTitle": "Chief Franchised Assets Officer",
        "organization": "Dan Company, PIF Subsidiary",
        "photoUrl": "https://static.swapcard.com/public/images/5149ca46de9840e2a58610ead5ef337d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI3MzQ2Mg==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MjU2ODU=",
        "type": "Speaker",
        "firstName": "Sebastien",
        "lastName": "Carre",
        "jobTitle": "Group Head of Hospitality",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5d687c7d1bd34fe383f0c0a3ba7da1c4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTExMzQ0Nw==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MjY5MjQ=",
        "type": "Speaker",
        "firstName": "Julien",
        "lastName": "Renaud-Perret",
        "jobTitle": "Executive Director Hospitality",
        "organization": "New Murabba Development Company",
        "photoUrl": "https://static.swapcard.com/public/images/1fb52e3267694691b0eca0cd3524a723.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzEwMDM1OQ==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0NTU5Mjk=",
        "type": "Speaker",
        "firstName": "Philip",
        "lastName": "Barnes",
        "jobTitle": "Chief Executive Officer",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/246b45805ccc406aa094b53884a16d4f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2ODQ4Mg==",
                    "createdAt": "2025-05-06 07:38:01"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0NTY2OTc=",
        "type": "Moderator",
        "firstName": "David",
        "lastName": "Keen",
        "jobTitle": "CEO & Founder",
        "organization": "QUO Global",
        "photoUrl": "https://static.swapcard.com/public/images/513c331c9e854a5e9989fdfe873448b3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkyMDc4Ng==",
                    "createdAt": "2025-05-06 07:38:02"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0NjY5MTU=",
        "type": "Moderator",
        "firstName": "Jade",
        "lastName": "Hall",
        "jobTitle": "Founding Director",
        "organization": "Astral Placemaking Group",
        "photoUrl": "https://static.swapcard.com/public/images/20ae492278794ffb805447011a571dad.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzEyOTM4OQ==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0ODk4MjM=",
        "type": "Speaker",
        "firstName": "Ibrahim",
        "lastName": "Alturki",
        "jobTitle": "Chairman",
        "organization": "Growth Partner",
        "photoUrl": "https://static.swapcard.com/public/images/f3a84e0a281f44c1a786dbbe6d2fc7e2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE0NTc4Nw==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0OTI1MTM=",
        "type": "Speaker",
        "firstName": "Gregory",
        "lastName": "Djerejian",
        "jobTitle": "Group Head of Investments",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/43eec2cbcadb41b7b2db67506365fd39.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE0Nzg4Mw==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0OTI1NDY=",
        "type": "Speaker",
        "firstName": "Pascal",
        "lastName": "Armoudom",
        "jobTitle": "Partner",
        "organization": "Kearney",
        "photoUrl": "https://static.swapcard.com/public/images/7be19e1298dd4c7ca64f06f4cec210a6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNzMyNDUxMA==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0OTY3MDU=",
        "type": null,
        "firstName": "Charlotte",
        "lastName": "Boutboul",
        "jobTitle": "Lead Urban Transformation & Tourism",
        "organization": "World Economic Forum",
        "photoUrl": "https://static.swapcard.com/public/images/0436bba0b0a94716a482baec4f3be6ff.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE0OTcwMg==",
                    "createdAt": "2025-05-07 16:37:29"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0OTY5MzE=",
        "type": "Speaker",
        "firstName": "Narjes",
        "lastName": "Mohammed",
        "jobTitle": "Revenue Manager",
        "organization": "Makkah clock Royal Tower. A Fairmont Hotel",
        "photoUrl": "https://static.swapcard.com/public/images/a8bd1871a3d04d8db3cd7156a77b5bee.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzM=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE0OTg1MA==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1MDA2ODg=",
        "type": "Speaker",
        "firstName": "Antony",
        "lastName": "Doucet",
        "jobTitle": "Chief Experience Officer",
        "organization": "Kerten Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/b6e466680e154bcf9f83b26c91b2e645.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2ODQ2Nw==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1MDI0MTI=",
        "type": "Speaker",
        "firstName": "Mahmoud",
        "lastName": "Abdulhadi",
        "jobTitle": "Deputy Minister, Destination Enablement",
        "organization": "Ministry of Tourism of Saudi Arabia",
        "photoUrl": "https://static.swapcard.com/public/images/56724beae060457ea3b07e98cba20646.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE1Mzg0OQ==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1MDkxMDk=",
        "type": null,
        "firstName": "Clare",
        "lastName": "Moukabaa",
        "jobTitle": "Partner-Residential Consultancy",
        "organization": "Knight Frank Middle East Limited",
        "photoUrl": "https://static.swapcard.com/public/images/0ee07435fc6c4c29a963cc3c1b3184e3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zODc3MzkzMA==",
                    "createdAt": "2025-05-07 16:37:30"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1MjEwMTI=",
        "type": "Speaker",
        "firstName": "Luc",
        "lastName": "Delafosse",
        "jobTitle": "Vice President, Hospitality Management,",
        "organization": "Al Khozama Investment Company",
        "photoUrl": "https://static.swapcard.com/public/images/1f75f521c6ea47fc8aadcdc06a488a7f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI4ODk2OQ==",
                    "createdAt": "2025-05-08 07:47:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1MjEyMDk=",
        "type": null,
        "firstName": "Elie",
        "lastName": "Milky",
        "jobTitle": "Chief Development Officer, The Middle East, Northeast Africa, Cyprus and Greece",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF81MDg0MzU=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzAzMw==",
                    "createdAt": "2025-05-08 07:47:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1NDMzMjA=",
        "type": "Speaker",
        "firstName": "Aseel",
        "lastName": "Hussain Bondagjy",
        "jobTitle": "Hotel Talent Development Manager",
        "organization": "NEOM",
        "photoUrl": "https://static.swapcard.com/public/images/7186201b027e4b559da332e0aae95aa3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyMTk3MA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTg3NzM4Mg==",
                    "createdAt": "2025-05-09 11:23:17"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk1NjQyNTU=",
        "type": "Speaker",
        "firstName": "Natasha",
        "lastName": "Martin",
        "jobTitle": "Director, Visitor Experience – Nature Reserve",
        "organization": "NEOM",
        "photoUrl": "https://static.swapcard.com/public/images/65f3b3eb8108429996df288db4a3aa7c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF81MDg0MzQ=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV80MzE5ODM0MA==",
                    "createdAt": "2025-05-10 08:25:46"
                }
            ]
        }
    }
]